export enum CardType {
    Confirm = 'Confirm',
    Filter = 'Filter',
    GlobalFilters = 'GlobalFilters',
    Notifications = 'Notifications',
    Stage = 'Stage',
    UpdateInfo = 'UpdateInfo',
};